export class Flag {
    public static values = [
        "Scheduled Inspection",
        "Initial Inspection",
        "Complaints",
        "Common Project Activities",
        "CHOW"
    ].sort()
}